const appraise = {
    namespaced: true,
    state: {
        pageParams: {},
        tabIds: [],
        tabName: 'SaleAssessment',
    },
    mutations: {
        setTabName(state, name){
            state.tabName = name;
        },
        setPageParams(state, params) {
            console.log(params)
            state.pageParams = params;
        },
        setTabIds(state,ids) {
            state.tabIds = ids;
        } 
    },
    actions: {
        setPageParamsAction({ commit }, params) {
            return new Promise(resolve => {
                commit('setPageParams', params);
                resolve()
            })
        },
        setTabIdsAction({ commit }, ids) {
            commit('setTabIds', ids);
        },
        setTabNameAction({ commit }, name) {
            commit('setTabName', name)
        }
    }
}

export default appraise;